import { ACCESSORIES_PROCESS_DC_INWARD_USERFORM_RESET, CREATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_FAILURE, CREATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_FORM, CREATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_REQUEST, CREATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_SUCCESS, DELETE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_FAILURE, DELETE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_REQUEST, DELETE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_SUCCESS, FETCH_ACCESSORIES_PROCESS_DC_INWARD_MASTER_FAILURE, FETCH_ACCESSORIES_PROCESS_DC_INWARD_MASTER_REQUEST, FETCH_ACCESSORIES_PROCESS_DC_INWARD_MASTER_SUCCESS, FETCH_PENDING_ACCESSORIES_PROCESS_DC_IN_INWARD_FAILURE, FETCH_PENDING_ACCESSORIES_PROCESS_DC_IN_INWARD_REQUEST, FETCH_PENDING_ACCESSORIES_PROCESS_DC_IN_INWARD_SUCCESS, FETCH_SINGLE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_FAILURE, FETCH_SINGLE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_REQUEST, FETCH_SINGLE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_SUCCESS, NAVIGATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS, NAVIGATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER, RESET_ACCESSORIES_PROCESS_DC_INWARD_MASTER_INFO, RESET_FORM_DATA_WITHOUT_INWARD_ID, SET_ACTIVE_KEY_ACCESSORIES_PROCESS_DC_INWARD_MASTER, SET_END_DATE_ACCESSORIES_PROCESS_DC_INWARD, SET_PENDING_GRID_NAME_ACCESSORIES_PROCESS_DC_INWARD, SET_START_DATE_ACCESSORIES_PROCESS_DC_INWARD, SET_UNIT_NAME_ACCESSORIES_INWARD, UPDATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_FAILURE, UPDATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_FORM, UPDATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_REQUEST, UPDATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_SUCCESS } from "./accessoriesProcessDCInwardHeader.actionsType";


export const ACCESSORIES_PROCESS_DC_INWARD_MASTER = 'accessoriesProcessDCInwardHeader';

let initialState = {
    loading: false,
    accessoriesProcessDCInwardHeader: [],
    pendingAccessoriesProcessDC: [],
    accessoriesProcessDCInwardHeaderForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: 0,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: 0
    },
    selectedState: {},
    renderGridBtn: 'pendingGrid',
    errorMessage: '',
    accessoriesInwardId: '',
    activeKey: 1,
    singleAccessoriesProcessDCInwardData: null,
    isAccessoriesProcessDCInwardDetails: false,
    unitId: 1,
    startDate: new Date().setDate(new Date().getDate() - 15),
    endDate: new Date(),
};

export let accessoriesProcessDCInwardHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ACCESSORIES_PROCESS_DC_INWARD_MASTER_REQUEST:
        case FETCH_PENDING_ACCESSORIES_PROCESS_DC_IN_INWARD_REQUEST:
        case CREATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_REQUEST:
        case UPDATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_REQUEST:
        case FETCH_SINGLE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_REQUEST:
        case DELETE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_PROCESS_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesProcessDCInwardHeader: updatePayload
            };
        case FETCH_PENDING_ACCESSORIES_PROCESS_DC_IN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingAccessoriesProcessDC: updatePayload
            };
        case CREATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesProcessDCInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                },
                accessoriesInwardId: updatePayload,
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case UPDATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesProcessDCInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                }
            };
        case FETCH_SINGLE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesProcessDCInwardHeaderForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case DELETE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesProcessDCInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                }
            };
        case RESET_ACCESSORIES_PROCESS_DC_INWARD_MASTER_INFO:
            return {
                ...state,
                accessoriesProcessDCInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                }
            };
        case CREATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_FORM:
        case UPDATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_FORM:
            return {
                ...state,
                loading: false,
                accessoriesProcessDCInwardHeaderForm: {
                    ...state.accessoriesProcessDCInwardHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case ACCESSORIES_PROCESS_DC_INWARD_USERFORM_RESET:
            return {
                ...state,
                accessoriesProcessDCInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                },
                accessoriesInwardId: '',
                selectedState: {},
                activeKey: 1
            };
        case FETCH_ACCESSORIES_PROCESS_DC_INWARD_MASTER_FAILURE:
        case FETCH_PENDING_ACCESSORIES_PROCESS_DC_IN_INWARD_FAILURE:
        case CREATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_FAILURE:
        case UPDATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_FAILURE:
        case FETCH_SINGLE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_FAILURE:
        case DELETE_ACCESSORIES_PROCESS_DC_INWARD_MASTER_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_ACCESSORIES_PROCESS_DC_INWARD_DETAILS:
            return {
                ...state,
                isAccessoriesProcessDCInwardDetails: true,
                singleAccessoriesProcessDCInwardData: updatePayload.singleAccessoriesProcessDCInwardData
            };
        case NAVIGATE_ACCESSORIES_PROCESS_DC_INWARD_MASTER:
            return {
                ...state,
                isAccessoriesProcessDCInwardDetails: false
            };
        case SET_PENDING_GRID_NAME_ACCESSORIES_PROCESS_DC_INWARD:
            return {
                ...state,
                renderGridBtn: payload
            };
        case SET_UNIT_NAME_ACCESSORIES_INWARD:
            return {
                ...state,
                unitId: payload
            };
        case SET_START_DATE_ACCESSORIES_PROCESS_DC_INWARD:
            return {
                ...state,
                startDate: payload
            };
        case SET_END_DATE_ACCESSORIES_PROCESS_DC_INWARD:
            return {
                ...state,
                endDate: payload
            };
        case SET_ACTIVE_KEY_ACCESSORIES_PROCESS_DC_INWARD_MASTER:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case RESET_FORM_DATA_WITHOUT_INWARD_ID:
            return {
                ...state,
                accessoriesProcessDCInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                },
                selectedState: {}
            };
        default:
            return state;
    }
};
